import React from 'react';
import { ThemeProvider } from 'styled-components';
import OImage from '../OImage';
import YouTube from '../YouTube';
import { getSrcset } from '../../ui/helpers';

import { Module, Container, Inner } from './styles';
import Wrapper from '../../ui/Wrappers';
import { themes } from '../../ui/design-tokens';
import Quote from '-!svg-react-loader!../../ui/svgs/icon-quote.svg';

interface IProps {
  theme?: string;
  heading?: string;
  title?: string;
  text: string;
  name?: string;
  role?: string;
  imageUrl?: any;
  imageAlt?: string;
  videoUrl?: any;
}

const Testimonials = ({
  theme,
  heading,
  title,
  text,
  name,
  role,
  imageUrl,
  imageAlt,
  videoUrl
}: IProps) => {
  const cleanedTheme = theme ? theme : 'neutral';
  const isGradient = cleanedTheme.endsWith('_gradient');
  let themeProp = themes.testimonials[cleanedTheme];
  if (isGradient) {
    themeProp = themes.gradients[cleanedTheme];
  }
  return (
    <ThemeProvider theme={themeProp}>
      <Wrapper size="mainwrapper" as={Module}>
        {title &&
          (title && heading === 'heading_2' ? (
            <h2 className="title">{title}</h2>
          ) : (
            <h3 className="title">{title}</h3>
          ))}

        <Wrapper size="mainwrapper" as={Container}>
          <div className="quotes">
            <Quote className="quote" />
          </div>
          <Wrapper size="reader" as={Inner}>
            <p className="p-big">{text}</p>
            {(name || role) && (
              <div className="person">
                {name && (
                  <p>
                    <b>{name}</b>
                  </p>
                )}
                {role && <p>{role}</p>}
              </div>
            )}
            {imageUrl && (
              <OImage
                src={imageUrl.original?.href}
                aspectRatio={imageUrl.original?.meta.width / imageUrl.original?.meta.height}
                srcSet={getSrcset(imageUrl)}
                webp={getSrcset(imageUrl, true)}
                className="image"
                alt={imageAlt || ''}
              />
            )}
            {videoUrl && <YouTube videoUrl={videoUrl} aspectRatio={16 / 9} className={'video'} />}
          </Wrapper>
        </Wrapper>
      </Wrapper>
    </ThemeProvider>
  );
};

export default Testimonials;
